// Shared formatting helpers for the dashboard charts. Underscore prefix marks
// this as a private util scoped to the dashboard folder — not a generic
// app-wide helper. Extracted from `revenue-sparkline.tsx` when it migrated
// from a hand-rolled SVG to a Recharts implementation.

const MONTH_ABBR_SHORT = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
] as const;

const MONTH_FULL = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
] as const;

export function parseIsoMonth(isoMonth: string): { year: string; idx: number } {
	const [year, monthStr] = isoMonth.split("-");
	const idx = monthStr ? Number.parseInt(monthStr, 10) - 1 : 0;
	return { year: year ?? "", idx };
}

export function formatMonthLabel(isoMonth: string): string {
	const { idx } = parseIsoMonth(isoMonth);
	return MONTH_ABBR_SHORT[idx] ?? "";
}

export function formatMonthLong(isoMonth: string): string {
	const { year, idx } = parseIsoMonth(isoMonth);
	return `${MONTH_FULL[idx] ?? ""} ${year}`.trim();
}

/**
 * "$8.4k" / "$1.2M" / "$432" — tuned for y-axis tick labels on a chart that
 * was already converted to dollar units (cents / 100) upstream. Keeping the
 * formatter a pure dollar→string fn lets Recharts hand us its tick value
 * directly without a re-conversion.
 */
export function formatCompactDollars(dollars: number): string {
	const abs = Math.abs(dollars);
	if (abs >= 1_000_000) return `$${(dollars / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
	if (abs >= 1_000) return `$${(dollars / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
	return `$${Math.round(dollars)}`;
}
